import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';

import RegisterPage from '@/components/Register/Register';
import { getOrFetchConfiguration } from '@/utils/getConfiguration';
import User from '@/store/user';
import { getCMSHomepageGrid } from '@/api/cms';
import { getOrFetchHeaderData } from '@/utils/headerCalls';
import LoginLayout from '@/components/LoginLayout/LoginLayout';
import { getLayoutProps } from '@/utils/layout/layout';
import Cookies from 'universal-cookie';

export default function Login({ logo, loginLogo, loginConfig, loginImage, responsiveLogo }) {
  const [config, setConfig] = useState();
  const [user, setUser] = useState();
  const router = useRouter();
  const cookies = new Cookies();

  const authorization = cookies.get('token');

  useEffect(() => {
    async function getConfiguration() {
      const configuration = await getOrFetchConfiguration();
      setConfig(configuration);
      return;
    }
    getConfiguration();
  }, []);

  if (authorization) router.replace('/');
  return (
    <>
      {config && (
        <LoginLayout type={loginConfig} image={loginImage} responsiveLogo={responsiveLogo}>
          <RegisterPage config={config} logo={loginLogo ? loginLogo : logo} type={loginConfig} />
        </LoginLayout>
      )}
    </>
  );
}

export async function getStaticProps(context) {
  const { responsiveLogo } = await getLayoutProps({ headerProps: { selectedIndex: -1 } }, context.locale);
  const [{ data: logoData }, { data: loginLogoData }, { data: loginAllData }] = await Promise.all([
    getCMSHomepageGrid('header_logo', context.locale),
    getOrFetchHeaderData('login_logo', context.locale),
    getOrFetchHeaderData('login_page', context.locale),
  ]);
  const logo = logoData.data[0].content.logo.url;
  const loginLogo = loginLogoData.data[0].content.login_logo.url;
  const loginConfig = loginAllData.data[0].content.configuration;
  const loginImage = loginAllData.data[0].content.image?.url ? loginAllData.data[0].content.image?.url : '';

  const messages = {
    common: (await import(`../../../prebuild-data/i18n/${context.locale}/common.json`)).default,
    login_register: (await import(`../../../prebuild-data/i18n/${context.locale}/login_register.json`)).default,
    guest_login: (await import(`../../../prebuild-data/i18n/${context.locale}/guest_login.json`)).default,
  };

  return {
    props: {
      responsiveLogo,
      logo,
      loginLogo,
      loginConfig,
      loginImage,
      messages,
    },
  };
}
